import React, { Component } from 'react'
import classnames from 'classnames'
import _ from 'lodash'
import { Button, Form, Input } from 'antd'
import { Select as SelectArea } from '@/components/SelectArea'
import styles from './tenants.module.scss'
import FilterItem from '@/components/FilterItem'

const formItemLayout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
}

@Form.create()
export default class Filters extends Component {
  normalizeTenant = (value, prevValue, allValues) => {
    if (typeof value === 'string') {
      return value
    }

    if (value && value._id) {
      return value._id
    }

    return null
  }

  normalizeOrder = (value, prevValue, allValues) => {
    if (typeof value === 'string') {
      return value
    }

    if (value && value._id) {
      return value._id
    }

    return null
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.error(err)
      }

      if (values.time_range && values.time_range[0] && values.time_range[1]) {
        values.time_range = [
          values.time_range[0].startOf('day').valueOf(),
          values.time_range[1].endOf('day').valueOf()
        ]
      }

      values = _.pickBy(values, _.identity)

      this.props.onChange(values)
    })
  }

  handleReset = () => {
    this.props.onChange({})
  }

  render() {
    const { getFieldDecorator } = this.props.form

    return (
      <Form onSubmit={this.handleSubmit} layout="inline">
        <div className={styles.filters}>

          <FilterItem
            className={styles.row}
            label="关键字">
            {getFieldDecorator('keyword')(
              <Input
                style={{ width: 220 }}
                placeholder="请输入关键字" />
            )}
          </FilterItem>
          <FilterItem
            className={styles.row}>
            <div className={styles.submitBtns}>
              <Button type="primary" htmlType="submit">查询</Button>
              {/* <Button type="default" style={{ marginLeft: 8 }} onClick={this.handleReset}>重置</Button> */}
            </div>
          </FilterItem>
        </div>
      </Form>
    )
  }
}
